<template>
	<section class="mb-5" :id="'section-' + item.type + '-' + index" :class="'section-'+item.type" v-for="(item, index) in componentsData">
		<news-page-section
				v-if="item.type === PageComponentTypeEnum.NEWS"
				:data="item"
		/>
		<about-us-page-section
				v-if="item.type === PageComponentTypeEnum.ABOUT_US"
				:data="item"
		/>
		<faq-page-section
				v-if="item.type === PageComponentTypeEnum.FAQS"
				:data="item"
		/>

		<highlighted-block-page-section
				v-if="item.type === PageComponentTypeEnum.HIGHLIGHTED_BLOCK"
				:data="item"
		/>
		<image-box-page-section
				v-if="item.type === PageComponentTypeEnum.IMAGE_BOX"
				:data="item"
		/>
		<partners-page-section
				v-if="item.type === PageComponentTypeEnum.PARTNERS"
				:data="item"
		/>
		<div v-if="item.type === PageComponentTypeEnum.CAROUSEL">
			<carousel-section :slides="item"/>
		</div>

		<form-component v-if="item.type === PageComponentTypeEnum.FORMS" :form-data="item.data" :show-title="item.show_title"/>
		<simple-text-component v-if="item.type === PageComponentTypeEnum.SIMPLE_TEXT" :title='item.title' :data="item.data" :show-title="item.show_title"/>
		<advert-card-section v-if="item.type === PageComponentTypeEnum.ADVERTS" :component="item"/>
		<team-component v-if="item.type === PageComponentTypeEnum.TEAM" :component="item"/>

		<div v-if="item.type === PageComponentTypeEnum.VIDEO" v-for="(data, index) in item.data ?? []">
			<video-card-component :data="data"/>
		</div>

		<div v-if="item.type === PageComponentTypeEnum.MAP">
			<google-maps-component :data="item.data"/>
		</div>

		<div v-if="item.type === PageComponentTypeEnum.SPLITTED_IMAGES">
			<splitted-images :data="item.data" />
		</div>

		<div v-if="item.type === PageComponentTypeEnum.SEARCH_BAR">
			<search-bar-section :data="item"/>
		</div>

		<div v-if="item.type === PageComponentTypeEnum.IMAGE_BOX_EXTENDED">
			<image-box-extended-page-section :item="item" />
		</div>

	</section>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import NewsPageSection from "./Sections/NewsPageSection.vue";
import {PageComponentClass, PageComponentInterface} from "./Interfaces/PageComponentInterface";
import {PageComponentTypeEnum} from './Enums/PageComponentTypeEnum';
import AboutUsPageSection from "./Sections/AboutUsPageSection.vue";
import FaqPageSection from "./Sections/FaqPageSection.vue";
import HighlightedBlockPageSection from "./Sections/HighlightedBlockPageSection.vue";
import ImageBoxPageSection from "./Sections/ImageBoxPageSection.vue";
import PartnersPageSection from "./Sections/PartnersPageSection.vue";
import CarouselSection from "../../Components/CarouselSection.vue";
import FormComponent from "./Sections/InlineComponents/FormComponent.vue";
import SimpleTextComponent from "./Sections/SimpleTextComponent.vue";
import AdvertCardSection from "./Sections/AdvertCardSection.vue";
import VideoCardComponent from "@/WebApp/Components/Video/VideoCardComponent.vue";
import {VideoTypeEnum} from "@/WebApp/Views/PageView/Enums/VideoTypeEnum";
import GoogleMapsComponent from "./Sections/GoogleMapsComponent.vue";
import TeamComponent from "@/WebApp/Views/PageView/Sections/TeamComponent.vue";
import SplittedImages from "./Sections/SplittedImages.vue";
import SearchBarSection from "./Sections/SearchBarSection.vue";
import ImageBoxExtendedPageSection from "./Sections/ImageBoxExtendedPageSection.vue";

export default defineComponent({
	name: "PageBuilder",
	methods: {
		VideoTypeEnum() {
			return VideoTypeEnum
		}
	},
	components: {
		TeamComponent,
		GoogleMapsComponent,
		VideoCardComponent,
		AdvertCardSection,
		CarouselSection,
		PartnersPageSection,
		ImageBoxPageSection,
		HighlightedBlockPageSection,
		FaqPageSection,
		AboutUsPageSection,
		NewsPageSection,
		FormComponent,
		SimpleTextComponent,
		SplittedImages,
		SearchBarSection,
		ImageBoxExtendedPageSection,
	},
	props: {
		componentsData: {
			type: Array as PropType<PageComponentInterface[]>,
			default: [],
			required: true
		}
	},
	computed: {
		PageComponentTypeEnum() {
			return PageComponentTypeEnum;
		}
	},
});
</script>

<style scoped>

</style>
